export class Periode {
  constructor (periode) {
    this.dateDebut = periode ? periode.dateDebut : null
    this.dateFin = periode ? periode.dateFin : null
    this.dateEcheance4jours = periode ? periode.dateEcheance4jours : null
    this.dateEcheance30jours = periode ? periode.dateEcheance30jours : null
    this.dateEcheance60jours = periode ? periode.dateEcheance60jours : null
    this.userUpdateLogin = periode ? periode.userUpdateLogin : null
  }
}
